import React from "react";

const CurveUp = ({ transformType, onHandleTransformType }) => {
  const handleClick = () => {
    onHandleTransformType();
  };

  const selected = transformType === "shear_down" ? "selected" : "";

  return (
    <li className={`transform-icon ${selected}`} onClick={handleClick}>
      <svg
        className="transform-icon__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 41.7 11.7"
        width="42"
        height="12"
      >
        <path
          className="transform-icon__path"
          d="M40.7 6.3C33.7 5.1 1 1 1 1M40.7 10.7C33.7 9.5 1 5.4 1 5.4"
        />
      </svg>
      <div className="transform-icon__title">
        Shear
        <br />
        Down
      </div>
    </li>
  );
};

export default CurveUp;
